import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CompetitorFilter, PagedFilter } from '@model';

@Component({
  selector: 'app-admin-actions-header',
  templateUrl: './admin-actions-header.component.html',
  styleUrls: ['./admin-actions-header.component.scss']
})
export class AdminActionsHeaderComponent {
  @Output() onExportToXls: EventEmitter<void> = new EventEmitter<void>();
  @Output() onExportToPdf: EventEmitter<void> = new EventEmitter<void>();
  @Input() isXlsVisible: boolean = true;
  @Input() isPdfVisible: boolean = true;

  exportToXls() {
    this.onExportToXls.emit();
  }

  exportToPdf() {
    this.onExportToPdf.emit();
  }
}
